import { Store, Banknote } from "lucide-react";

interface Props {
  onAction: () => void;
  actionLabel: string;
  actionColor?: string;
}

const CashSessionHeader: React.FC<Props> = ({
  onAction,
  actionLabel,
  actionColor = "#DC3545",
}) => {
  return (
    <div className="flex flex-col gap-4 border-b border-stroke px-6 py-5 dark:border-strokedark sm:flex-row sm:items-center sm:justify-between">

      {/* LEFT SECTION */}
      <div className="flex items-center gap-3">

        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Store size={18} />
        </div>

        <div>
          <h4 className="font-medium text-black dark:text-white">
            Sesión de Caja
          </h4>

          <p className="text-sm text-gray-500">
            Información de la sesión activa
          </p>
        </div>

      </div>

      {/* ACTION BUTTON */}
      <button
        onClick={onAction}
        style={{ backgroundColor: actionColor }}
        className="inline-flex items-center justify-center gap-2 rounded px-4 py-2 text-sm font-medium text-white hover:opacity-90 sm:w-auto w-full"
      >
        <Banknote size={16} />
        {actionLabel}
      </button>

    </div>
  );
};

export default CashSessionHeader;